<template>
    <Icon v-if="icon" :name="icon" :size="16" :class="iconColor({ state: props.state as FormFieldValidationState })" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { cva } from 'class-variance-authority'
import Icon from '../icon/Icon.vue'
import type { IconName } from '../icon/types'
import type { FormFieldValidationState } from './types'

const props = defineProps<{
    state: FormFieldValidationState | null
}>()

const icons: Record<FormFieldValidationState, IconName> = {
    error: 'exclamation-circle',
    success: 'check-circle',
    warning: 'exclamation-triangle',
    missing: 'exclamation-triangle',
}

const icon = computed(() => props.state && icons[props.state])

const iconColor = cva('', {
    variants: {
        state: {
            error: 'text-error-core',
            success: 'text-success-core',
            warning: 'text-warning-core',
            missing: 'text-missing-core',
        },
    },
})

</script>
